module.exports = __webpack_public_path__ + "static/assets/08ec0a98517212b26bd0c4109cb5b08c.png";